// extracted by mini-css-extract-plugin
export default {"card":"p2-z","carouselContainer":"q2-z","carouselContent":"r2-z"};